import { MasterData } from "../service";
import { useMasterDataContext } from "../shared/context/MasterDataContext";

export interface MasterDataHookReturn {
  masterData: MasterData[];
  capabilitiesData: String[];
  filterMapData: any;
  projectsFilterData: any;
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
  clearError: () => void;
  clearMasterData: () => void;
};

export interface capabilitiesDataHookReturn {
  capabilitiesData: String[];
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
  clearError: () => void;
};

export interface MetaDataType {
  alias_name: string;
  label: string;
  domain: string;
};

export const useDisplayField = (metaData: MetaDataType | null | any) => {

  const { getDisplayText, getLabel, getDomain, getByDomain, getFilterOptions } = useMasterDataContext();

  const getMasterDataLabel = (value: string | string[], key: string) => {
    let values: any = [];
    let domain = getDomain(key, metaData);
    if (Array.isArray(value)) {
      value.map((item) => {
        values.push(getDisplayText(item, getDomain(key, metaData)) || value);
      });
      return values.join(', ');
    }
    return domain ? getDisplayText(value, domain) : value;
  };

  const getMetaDataLabel = (key: string) => {
    return getLabel(key, metaData);
  };

  const getOptions = (key: string) => {
    const response = getDomain(key, metaData);
    if (response) {
      return getByDomain(response).filter((value) => {
        return value.is_active;
      }).sort((a, b) => {
        return a.display_order - b.display_order;
      });
    } else {
      return [];
    }
  };

  return {
    getDomain,
    getMasterDataLabel,
    getMetaDataLabel,
    getOptions,
    getByDomain,
    getFilterOptions
  };
};
